<template>
  <VCard
    key="login"
    class="login-form"
  >
    <div class="logo">
      <VLogo/>
    </div>

    <header>
      <span>Вход</span>
      /
      <router-link to="/login/registration">
        Регистрация
      </router-link>
    </header>

    <VForm
      ref="form"
    >
      <div class="form">
        <VInput
          v-model="form.email"
          label="Почта"
          layout="vertical"
          required
          hide-asterisk
          type="email"
          autocomplete="email"
          @keyup.enter="onSubmit"
        />

        <VInput
          v-model="form.password"
          label="Пароль"
          layout="vertical"
          autocomplete="current-password"
          type="password"
          required
          hide-asterisk
          @keyup.enter="onSubmit"
        />

        <FormAgreementCheckbox :form="form"/>

        <div class="actions-wrap">
          <VButton
            :disabled="isLoading"
            theme="primary"
            @click="onSubmit"
          >
            Войти
          </VButton>

          <VButton
            type="button"
            @click="$router.push('/login/restore')"
          >
            Забыли пароль?
          </VButton>
        </div>

        <div class="helper-link">
          <VButton
            theme="link"
            type="button"
            @click="$router.push('/login/code')"
          >
            У меня есть код
          </VButton>
        </div>
      </div>
    </VForm>
  </VCard>
</template>

<style lang="scss" src="./LoginView.scss" />

<script>
import { getUserHomePath } from '@/router';

import GlobalLoader from "@/core/services/GlobalLoader/GlobalLoader";

import LoginForm from "@/pages/common/LoginPage/LoginForm";
import ContractsPublicDAO from "@/domains/Contracts/ContractsPublicDAO.js";

import VLogo from "@/lib/components/VLogo/VLogo.vue";
import ValidationFormMixin   from "@/mixins/validation-form-mixin.js";
import FormAgreementCheckbox from "@/pages/common/LoginPage/components/FormAgreementCheckbox.vue";

export default defineComponent({
  name: 'LoginView',

  mixins: [
    ValidationFormMixin
  ],

  components: {
    FormAgreementCheckbox,
    VLogo
  },

  data() {
    return {
      form: new LoginForm(),
    };
  },

  computed: {
    isLoading() {
      return GlobalLoader.isVisible;
    },

    formValid() {
      return this.form.allAgreementsAccepted
        && this.form.email
        && this.form.password;
    }
  },

  methods: {
    async onSubmit() {
      if (this.isLoading || !this.formValid) {
        return;
      }

      await this.validate();

      if (!this.isValid) {
        return;
      }

      this.form.saveAgreementFlagsToLocalStorage();

      try {
        await this.$core.acl.login(this.form.email, this.form.password);

        const contracts = await this.form.getAcceptedContracts();
        await ContractsPublicDAO.accept(contracts);

        /** Обновляем юзера, чтобы contractAcceptances подтянулись */
        await this.$core.acl.updateCurrentUserData();

        this.$router.push({ path: getUserHomePath() });
      } catch (error) {
        this.$core.showNotification.error('Не найдена такая пара почта и пароль.');
      }
    },
  },
});
</script>
